import FormPersonResponsible from './FormPersonResponsible';

export default FormPersonResponsible;